export class User {
  /**
   * @deprecated - should use the firebaseUid
   */
  id: number;
  firebaseUid: string;
  credentialHash: string | null;
  role: string;
  username: string;
  displayName: string;
  machineRoles: string | null;
  agreementAccepted: boolean;
  banned: boolean;
  samlUser: boolean;
  tableauUserIds: string | null;
  language: string;
  notificationRetentionDays: number;
  parentId: number;
  parentName: string;
  machineGroupName: string;
  machineGroup: number;
  whiteListedMachineryGroupsMap: { [key: number]: boolean };

  constructor(user?) {
    this.id = user?.id || -1;
    this.firebaseUid = user?.firebaseUid || '';
    this.credentialHash = user?.credentialHash || null;
    this.role = user?.role || '';
    this.username = user?.username || '';
    this.displayName = user?.displayName || '';
    this.machineRoles = user?.machineRoles || null;
    this.agreementAccepted = user?.agreementAccepted || false;
    this.banned = user?.banned || false;
    this.samlUser = user?.samlUser || false;
    this.tableauUserIds = user?.tableauUserIds || null;
    this.language = user?.language || '';
    this.notificationRetentionDays = user?.notificationRetentionDays || 0;
    this.parentId = user?.parentId || 0;
    this.parentName = user?.parentName || '';
    this.machineGroupName = user?.machineGroupName || '';
    this.machineGroup = user?.machineGroup || 0;
    this.whiteListedMachineryGroupsMap = user?.whiteListedMachineryGroupsMap || {};
  }

  public isWhiteListedUser() {
    if (!this.whiteListedMachineryGroupsMap) {
      return false;
    }
    for (const id in this.whiteListedMachineryGroupsMap) {
      if (this.whiteListedMachineryGroupsMap[id]) {
        return true;
      }
    }
    return false;
  }

  public getWhiteListedMachineryGroups(availableOnly?: boolean): number[] {
    const acc: number[] = [];
    for (const id in this.whiteListedMachineryGroupsMap) {
      if (availableOnly) {
        if (this.whiteListedMachineryGroupsMap[id]) {
          acc.push(+id);
        }
      } else {
        acc.push(+id);
      }
    }
    return acc;
  }
}
